import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZRead = z.object({
  readingTime: z.string().nullable(),
  value: z.number().nullable(),
  indexValue: z.number().nullable()
})

const ZReadingcimCodeIds = z.object({
  cimCodeId: z.string(),
  units: z.string().nullable(),
  latestValue: z.number().nullable().optional(),
  registerName: z.string().optional(),
  alarmLowerLimit: z.number().nullable().optional(),
  alarmHigherLimit: z.number().nullable().optional(),
  errorMessage: z.string().optional(),
  registerReadings: z.array(ZRead).optional()
})

const ZIntervalReadingAssetData = z.object({
  deviceId: z.string(),
  registerReadings: z.array(ZReadingcimCodeIds).optional()
})

export const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: z.array(ZIntervalReadingAssetData)
})

export type AssetPerformanceLineDataDashboard = z.infer<typeof ZIntervalReadingAssetData>
export type AssetPerformanceLineData = z.infer<typeof ZApiResponse>

export async function getAssetPerformanceLineData (
  startDate: string,
  endDate: string,
  graphName: string,
  requestParameter: any,
  isdefault: boolean,
  onSuccess: (AssetPerformanceLineData: any, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any
): Promise<void> {
  const url = `/asset-data-service/api/v1/udp/tiq/assets/data/interval/asset/data?startDate=${startDate}&endDate=${endDate}&graphName=${graphName}&isDefault=${isdefault.toString()}`
  interceptedAxios
    .post(url, requestParameter, {
      timeout: 80000,
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {
      if (response.status === 200) {
        const parseResponse = ZApiResponse.safeParse(response.data)
        if (parseResponse.success) {
          if (response.data.data !== null && response.data.data !== undefined) {
            onSuccess(parseResponse.data.data, response.status)
          }
        } else {
          onFailure(parseResponse.error.message, response.status)
        }
      } else if (response.status === 204) {
        onFailure('No Content', response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
